export default __webpack_public_path__ + "static/media/photo--lg--group-full.43779c82.jpg";